import { curry, startsWith } from 'lodash/fp';

export const isLinkActive = curry((route, match, location) =>
  route !== '/'
    ? startsWith(route, location.pathname)
    : route === location.pathname,
);
